export type LegacyReportingParamsInput = {
  selectedReporting: number;
  startdateformat: string;
  enddateformat: string;
  selectedCity: number | null;
  selectedMarket: string;
  selectedPeriodicity: string;
  selectedPlacer: string;
  absencesubscribedcheckvalue: number;
  billingvolantcheckvalue: number;
  billingSubscribedValue: number;
  valueDateFilterValue: number;
  extensionsubscriptionvalue: number;
  cashDepositValue: number;
  cashDepositCompleteValue: number;
  unpaidmerchantvalue: number;
  unpaidvalue16: boolean;
  unpaidvalue17: boolean;
  unpaidvalue18: boolean;
  unpaidvalue19: boolean;
  eventvalue: number;
  eventinfractionvalue: boolean;
  eventincidentvalue: boolean;
  eventvisitvalue: boolean;
  recapMerchantValue: number;
  subscriptionInValue: number;
  subscriptionOutValue: number;
  incomeWithPlacerValue: number;
  chartsValue: number;
  cityRegroupValue: number;
  cityRegroup2Value: number;
  maskColumnValue: number;
  selectedMarkets: number[];
  selectedColumns: string[];
};

export const buildLegacyReportingBody = (
  input: LegacyReportingParamsInput,
) => {
  return {
    type: input.selectedReporting,
    from: input.startdateformat ?? '',
    to: input.enddateformat ?? '',
    cityId: input.selectedCity,
    marketId: input.selectedMarket || null,
    periodicityId: input.selectedPeriodicity ? Number(input.selectedPeriodicity) : null,
    placerId: input.selectedPlacer ? Number(input.selectedPlacer) : null,
    absencesubscribedcheckvalue: input.absencesubscribedcheckvalue,
    billingvolantcheckvalue: input.billingvolantcheckvalue,
    billingSubscribedValue: input.billingSubscribedValue,
    valueDateFilterValue: input.valueDateFilterValue,
    extensionsubscriptionvalue: input.extensionsubscriptionvalue,
    cashDepositValue: input.cashDepositValue,
    cashDepositCompleteValue: input.cashDepositCompleteValue,
    unpaidmerchantvalue: input.unpaidmerchantvalue,
    unpaidvalue16: input.unpaidvalue16 ? 1 : 0,
    unpaidvalue17: input.unpaidvalue17 ? 1 : 0,
    unpaidvalue18: input.unpaidvalue18 ? 1 : 0,
    unpaidvalue19: input.unpaidvalue19 ? 1 : 0,
    eventvalue: input.eventvalue,
    eventinfractionvalue: input.eventinfractionvalue ? 1 : 0,
    eventincidentvalue: input.eventincidentvalue ? 1 : 0,
    eventvisitvalue: input.eventvisitvalue ? 1 : 0,
    recapMerchantValue: input.recapMerchantValue,
    subscriptionInValue: input.subscriptionInValue,
    subscriptionOutValue: input.subscriptionOutValue,
    incomeWithPlacerValue: input.incomeWithPlacerValue,
    chartsValue: input.chartsValue,
    cityRegroupValue: input.cityRegroupValue,
    cityRegroup2Value: input.cityRegroup2Value,
    maskColumnValue: input.maskColumnValue,
    marketIds: input.selectedMarkets,
    columnKeys: input.selectedColumns,
  };
};
